import { Component, ViewEncapsulation, OnDestroy } from "@angular/core";
import { MenuController } from "@ionic/angular";
import { Customer } from "../../../../providers/customer/customer";
import { Addresses } from "../../../../providers/customer/addresses";
import { Events } from 'src/providers/events/events';
import { Subscription } from 'rxjs';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

@Component({
    selector: 'tidy-missing-field',
    templateUrl: 'tidy-missing-field.html',
    styleUrls: ['./tidy-missing-field.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TidyMissingField implements OnDestroy {

  missingPhone = false;
  missingHomeAccess = false;
  missingParking = false;
  settings: any;
  addressInfo: any;
  addressUpdateSub: Subscription;
  addressChangeSub: Subscription;

  constructor(
    private addresses: Addresses,
    private customer: Customer,
    private events: Events,
    private menu: MenuController,
    private navCtrl: CustomNavController,
  ) {
    this.loadData();
    this.addressUpdateSub = this.events.subscribe('address-info-update', (data) => {
      this.checkSettingsFields(data.settings);
      this.checkAddressInfoFields(data.info);
    });
    this.addressChangeSub = this.events.subscribe('address:changed', addressInfoData => {
      this.checkAddressInfoFields(addressInfoData);
    })
  }

  async loadData() {
    this.settings = await this.customer.settings();
    this.addressInfo =  await this.addresses.getAddress();
    this.checkSettingsFields(this.settings);
    this.checkAddressInfoFields(this.addressInfo);
  }

  goToAddressInfo() {
    this.navCtrl.navigateForward('address-info');
    this.menu.close();
  }

  checkAddressInfoFields(addressInfoData) {
    const parkingFields = { 'true' : ['paid_parking', 'parking_spot', 'parking_pay_with', 'max_parking_cost', 'parking_notes'],
                            'false': ['paid_parking', 'parking_spot', 'parking_notes'] };
    this.missingHomeAccess = addressInfoData.home_access ? false : true;
    this.missingParking = false;
    addressInfoData.paid_parking = (addressInfoData.paid_parking === 'true' || addressInfoData.paid_parking === true);

    const fieldsSelector = addressInfoData.paid_parking ? 'true' : 'false';
    parkingFields[fieldsSelector].forEach((field) => {
      if (addressInfoData[field] === null || addressInfoData[field] === '') {
        this.missingParking = true;
      }
    });
  }

  checkSettingsFields(settingsData) {
    const phone = settingsData.profile.phone;
    if (phone) {
      const matchedPhone = phone.replace(/[^0-9]/g, '').match(/^[1-9]?\d{10}$/);
      this.missingPhone = !matchedPhone;
    } else {
      this.missingPhone = true;
    }
  }

  ngOnDestroy() {
    this.addressUpdateSub.unsubscribe();
    this.addressChangeSub.unsubscribe();
  }
}
